export default "__VITE_ASSET__CM4Xo7kV__"